import { useContext } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import styles from './PayMeLink.module.css';
import { ActivationContext } from '../../activation/Activation';
import { ReactComponent as PaperclipIcon } from '../../components/svg/PaperclipIcon.svg';
import { CopyButton } from '../CopyButton/CopyButton';
import { LockedButton } from '../LockedButton/LockedButton';
import { copy } from '../util/copy';

export const PayMeLink = ({ payMeUrl }: { payMeUrl: string }) => {
  const { isOnboarded, isLoading } = useContext(ActivationContext);
  const url = isOnboarded ? payMeUrl : 'https://iwocaPay.me/ExampleCompanyLtd';

  const currentUrl = window.location.pathname;
  if (isLoading) return null;

  return (
    <div className={styles.linkContainer}>
      {isOnboarded ? (
        <>
          <input
            className={styles.payMeInput}
            type="text"
            readOnly={true}
            value={url}
            data-testid="copyInputValue"
          />
          <CopyButton
            className={styles.copyButton}
            onClick={async () => {
              await copy(payMeUrl);
              tracking.ampli.payLinkCopied({ url: currentUrl });
            }}
            title="Copy iwocaPay link"
          >
            <PaperclipIcon />
            <span>Copy</span>
          </CopyButton>
        </>
      ) : (
        <LockedButton />
      )}
    </div>
  );
};
